import { makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IPackageList } from '../../models/IPackage';
import { API_VERSION, PACKAGES_PATH } from '../constants/RestApiConstants';

export interface IListPackagesResponse {
  packages?: IPackageList;
}

export class ListPackagesService {
  public static listPackages(): Promise<IListPackagesResponse> {
    return makeJsonRestApiRequest<void, IListPackagesResponse>({
      config: {
        restApiVersion: API_VERSION,
        httpMethod: 'GET',
        endpoint: PACKAGES_PATH,
      },
      request: null,
    });
  }
}
